export const routes = [
  {
    path: "/painel-revisoes-tecnicas",
    name: "technical-review-dashboard",
    component: () => import("./components/TechnicalReviewDashboard.vue"),
    meta: { requiresAuth: true },
  },
];

export default routes;
